import React, { useEffect, useState } from "react";
import ProfileInfo from "./components/ProfileInfo";
import styles from "./UserProfile.module.css";
import PersonalInfo from "./components/ProfileCards";
import { useNavigate } from "react-router-dom";
import ModelProfile from "./components/Others/UpdateProfile";
import DeleteModelProfile from "./components/Others/DeleteConfirmationModel";
import { useDispatch } from "react-redux";
import { getUserProfile } from "../../redux/slices/profileSlice";

const UserProfile = ({ setPageTitle, setPage }) => {


  const navigate = useNavigate()
  const [data, setData] = useState({});
  const [updateProfileInfo, setUpdateProfileInfo] = useState({}); // State to store updated profile values
  const [openModel, setOpenModel] = useState(false); // State to handle open/close of model
  const [inputValues, setInputValues] = useState(); // State to store input values
  const [selectedImg, setSelectedImg] = useState(); // State to store selected image
  const [deleteModel, setDeleteModel] = useState(false); // State to handle open/clode of delete model

  const dispatch = useDispatch();

  useEffect(() => {
    setPageTitle("profile");
    setPage("profile");
    const token = localStorage.getItem("token");
    try {
      dispatch(getUserProfile(token));
    } catch (error) {
      console.log(error);
    }
  }, []);

  // Storing new profile values in state
  useEffect(() => {
    if (inputValues) {
      const valuesToUpdate = inputValues;
      valuesToUpdate["image"] =
        selectedImg || localStorage.getItem("selectedImageURL");

      setUpdateProfileInfo(valuesToUpdate);
    }
  }, [inputValues, data]);

  // If token is not available redrecting to login page
  if (!localStorage.getItem("token")) {
    navigate("auth/login");
  }

  return (
    <>
      <div className={styles.profile}>
        <div className={styles.wrapper}>
          <div className={styles.information}>
            <div className={styles.profileHero}>
              <ProfileInfo
                data={data}
                setData={setData}
                setOpenModel={setOpenModel}
                selectedImg={selectedImg}
                setSelectedImg={setSelectedImg}
              />
            </div>
            <div className={styles.profileCards}>
              <PersonalInfo data={data} setModel={setDeleteModel} />
            </div>
          </div>
        </div>
      </div>

      {openModel && (
        <ModelProfile 
          setOpenModel={setOpenModel}
          setInputValues={setInputValues}
          data={data}
          updateProfileInfo={updateProfileInfo}
        />
      )}

      {deleteModel && <DeleteModelProfile setDeleteModel={setDeleteModel} setOpenModel={setOpenModel} type="delete" header="Are you sure to delete your account?" />}
    </>
  );
};

export default UserProfile;
